export default __webpack_public_path__ + "static/media/room-geleia-real-main.b05cc91c.webp";